import { toastContainerSchema } from '@/@types/schemas/toast-containers'
import { showError } from '@/components/toast'
import { useRouteCompanyId } from '@/hooks/use-route-company-id'
import {
  createCompanyUpload,
  uploadCompanyFile,
  type UploadEntityType,
} from '@/services/fintalk/services/fintalk-backoffice/companies/create-upload'
import { sanitizerFileName } from '@/utils/validators/files/sanitizers'

import useTranslator from '../../translation'

export const useUploadFiles = () => {
  const routeCompanyId = useRouteCompanyId()

  const { getTranslation } = useTranslator()

  const uploadFile = async (
    file: File,
    entityType: UploadEntityType,
    companyId?: string,
  ) => {
    const id = companyId || routeCompanyId

    if (!id) return null

    try {
      const { key, pre_signed_url: preSignedUrl } = await createCompanyUpload({
        companyId: id,
        mimeType: file.type,
        entityType,
      })

      const sanitizedFileName = sanitizerFileName(file.name)
      const sanitizedFile = new File([file], sanitizedFileName, {
        type: file.type,
      })

      await uploadCompanyFile(preSignedUrl, sanitizedFile)

      return key
    } catch {
      showError({
        title: getTranslation('common.toast.error.imageUpload.title'),
        description: getTranslation(
          'common.toast.error.imageUpload.description',
        ),
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return null
    }
  }

  return {
    uploadFile,
  }
}
